import { makeStyles } from '@material-ui/core';
import { MainTheme } from '@paretogroup/tess';
import styled from 'styled-components';

export const useStyles = makeStyles(() => ({
    applyButton: {
        backgroundColor: MainTheme.colors['gray-6'],
        fontSize: '14px',
        marginTop: '18px',
        WebkitTextFillColor: MainTheme.colors['regal-blue-50'],
    },
}));

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SelectWrapper = styled.div`
  & + div {
    margin-top: 16px;
  }
`;
